const eventMapper = {
    ActionItem_plus: 'ActionItem:plus',
    ActionItem_settings: 'ActionItem:settings',
    ActionItem_map: 'ActionItem:map',
    ActionItem_edit: 'ActionItem:edit',
    ActionItem_workers: 'ActionItem:workers',
    Tab_handleClickTab: 'TAB:handleClickTab',
    FAB_refresh: 'FAB:refresh',
    // 결제정보 변경 성공 이벤트
    AdjustPaymentDialog_success: 'AdjustPaymentDialog:success',
    // 소켓
    Socket_handlePushOrder: 'Socket_handlePushOrder',
    Socket_handlePushFulfillment: 'Socket_handlePushFulfillment',
    // 지도관제
    MapWrapper_handleClickStore: 'MapWrapper:handleClickStore',
    MapWrapper_handleClickWorker: 'MapWrapper:handleClickWorker',
    MapWrapper_handleClickOrderFilter: 'MapWrapper:handleClickOrderFilter',
    MapWrapper_handleClickWorkerFilter: 'MapWrapper:handleClickWorkerFilter',
    MapWrapper_handleClickOrder: 'MapWrapper:handleClickOrder',
    MapWrapper_goToWorkerItem: 'MapWrapper:goToWorkerItem',
    MapWrapper_goToSelectedOrder: 'MapWrapper:goToSelectedOrder',
    MapWrapper_handleClickWorkerSearch: 'MapWrapper:handleClickWorkerSearch',
    MapWrapper_handleClickOrderSearch: 'MapWrapper:handleClickOrderSearch',
    MapWrapper_resetSearchQuery: 'MapWrapper:resetSearchQuery',
    MapWrapper_actionEsc: 'MapWrapper:actionEsc',
    MapWrapper_updateMarkerStoreAndDrop: 'MapWrapper:updateMarkerStoreAndDrop',
    MapWrapper_actionConnectSocket: 'MapWrapper:actionConnectSocket',
    MapWrapper_decreaseWorkerWeightAndUpdateMarker: 'MapWrapper:decreaseWorkerWeightAndUpdateMarker',
    MapWrapper_decreaseOrderWeightAndUpdateMarker: 'MapWrapper:decreaseOrderWeightAndUpdateMarker',
    MapWrapper_handleMouseHoverOrderItem: 'MapWrapper:handleMouseHoverOrderItem',
    MapWrapper_handleMouseLeaveOrderItem: 'MapWrapper:handleMouseLeaveOrderItem',
    // 목록관제
    ListControl_handleClickOrderSearch: 'ListControl_handleClickOrderSearch',
    ListControl_handleClickOrderFilter: 'ListControl_handleClickOrderFilter',
    // ModalOrderInfo
    ModalOrderInfo_success: 'ModalOrderInfo:success',
    ModalOrderInfo_fail: 'ModalOrderInfo:fail',
};
export default eventMapper;
